// Initialise the DataTable
let totalsTable = $('#totals-grid').DataTable({
    columnDefs: [
        { orderSequence: ['desc', 'asc', ''], targets: '_all' },
    ],
    fixedColumns: { left: 2 },
    fixedHeader: {
        header: true,
        footer: true,
    },
    initComplete: function () {
        $('.placement-grid-wrapper').removeClass('d-none');
    },
    language: { lengthMenu: 'Show _MENU_ entries' },
    lengthMenu: [10, 25, 50, 100, 200, -1],
    orderCellsTop: true,
    pageLength: -1,
    scrollX: true,
    searchDelay: 350,
});

const savedTerm = localStorage.getItem('selectedTerm') || 'all';
applyTermFilter(savedTerm);

$('#term-filter a').on('click', function (e) {
    e.preventDefault();
    const selectedTerm = $(this).data('term');
    // Save selected term to localStorage
    localStorage.setItem('selectedTerm', selectedTerm);
    applyTermFilter(selectedTerm);
});

function applyTermFilter(selectedTerm) {
    $('#term-filter li').removeClass('active');
    $('#term-filter a[data-term="' + selectedTerm + '"]')
        .parent()
        .addClass('active');

    totalsTable.columns().every(function () {
        const header = $(this.header());

        if (header.hasClass('term-one-column')) {
            this.visible(selectedTerm === 'all' || selectedTerm === 'one', false);
        } else if (header.hasClass('term-two-column')) {
            this.visible(selectedTerm === 'all' || selectedTerm === 'two', false);
        }
    });

    totalsTable.columns.adjust();
}
